<div class="content__container">
    <div class="content__title">{{title()}}</div>
    <div *ngIf="isShow" class="content__share__btn">
        <app-share-button></app-share-button>
    </div>
    <!-- Invalid BEM convention -->
    <div class="content__share__icons">
        <button type="button" class="icon-button" (click)="onClickShare()" (keydown)="onClickShare()" tabindex="0">
            <img src="assets/icons/share.svg" alt="icon-share">
        </button>
    </div>
    <div class="content__image">
        <div class="wrap__image">
            @if (imageUrl()) {
                <button type="button" class="banner-button" (click)="onBannerClick()" (keydown)="onBannerClick()" tabindex="0">
                <img width="345" height="196" [src]="imageUrl()" alt="content" priority="true" />
            </button>
            }@else {
                <p>Loading...</p>
            }
        </div>
    </div>
    <div class="content__description " [innerHTML]="description() | safe:'html'"></div>
</div>
